import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { Modal } from "react-responsive-modal";
import { BsXCircle } from "react-icons/bs";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import "react-responsive-modal/styles.css";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";
import PageShell from "../../../../components/layout/PageShell";
import PageHead from "../../../../components/layout/PageHead";

const Languagelist = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setID] = useState();
  let token = localStorage.getItem("accessToken");

  const onCloseModal = () => setOpen(false);
  const onOpenModal = (id) => {
    setOpen(true);
    setID(id);
  };

//   const search = (data) => {
//     return data?.filter(
//       (item) =>
//         item?.page_title_en?.toLowerCase()?.includes(query) ||
//         item?.page_content_en?.toLowerCase()?.includes(query) ||
//         item?.slug?.toLowerCase()?.includes(query)
//     );
//   };

  const deletePageData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "delete",
      url: process.env.REACT_APP_API + "page",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.status == 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          onCloseModal();
          fetchaboutData();
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const fetchaboutData = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "languages-text-admin",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(response);
        setData(response.data.data);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchaboutData();
  }, []);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/language/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            <Link
              to={`/language/edit/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">
                <EditOutlinedIcon />
              </div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => onOpenModal(params.row.id)}
            >
              <DeleteOutlineIcon />
            </div>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "section",
      headerName: "Section",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "key",
      headerName: "Key",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "english",
      headerName: "English",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "french",
      headerName: "French",
      flex: 1,
      minWidth: 170,
    },
  ];

  return (
    <PageShell><PageHead title="Languages" /><div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Pages</h5>
        <Link to="/language/add-language" className="link">
          Add New
        </Link>
      </div>
      {open && (
        <Modal
          open={open}
          center
          onClose={onCloseModal}
          closeOnOverlayClick={false}
          classNames={{
            modal: "customModal",
          }}
        >
          <div className="container-modal">
            <div className="modal-header">
              <BsXCircle color={"#dc3545"} size={"3em"} />
              <h4>Are you sure?</h4>
            </div>
            <div className="confirmation-text">
              Do you really want to delete this task?
            </div>
            <div className="button-container">
              <button className="cancel-button" onClick={() => onCloseModal()}>
                Cancel
              </button>
              <button
                className="confirmation-button"
                onClick={() => deletePageData()}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      <DataGrid
        autoHeight
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
      />
    </div></PageShell>
  );
};

export default Languagelist;
